import Page from '@/components/common/page';
import { InfoTemplateArticleContents } from '../common/info-template-article-contents';
import { Entities } from '../common/entities';
import { forEachNode } from '../../utils/forEachNode';
import { initializeSearchInputs } from '../common/search/search-input';
import { InfoTemplateDropdown } from '../common/info-template-dropdown';
import { SearchModal } from '../common/search/search-modal';
import { initializeNewsCarousel } from './new-news-swiper';

export class NewNewsPageArticle extends Page {
    init() {
        new Entities(
            '.info-template__categories-navigation-link',
            (category) => {
                const icons = category.querySelectorAll('.info-template__categories-navigation-icon')
                const topicList = category.nextElementSibling
            
                category.classList.toggle('info-template__categories-navigation-link_active')
                forEachNode(icons, (icon) => icon.classList.toggle('info-template__categories-navigation-icon_active'))
                topicList?.classList.toggle('info-template__categories-navigation-topics_active')
            });
        new Entities(
            '.new-news-category__partition',
            (article) => {
                window.location.href = article.dataset.link;
            });
        new InfoTemplateDropdown;
        new SearchModal('news');

        new InfoTemplateArticleContents;

        initializeSearchInputs(
            document.querySelectorAll('.search-input'),
            document.querySelectorAll('.search-input__button'),
            'news'
        );

        initializeNewsCarousel();
    }
}
